import { render, staticRenderFns } from "./BigStat.vue?vue&type=template&id=2a1bc641&scoped=true&"
import script from "./BigStat.vue?vue&type=script&lang=js&"
export * from "./BigStat.vue?vue&type=script&lang=js&"
import style0 from "./BigStat.scss?vue&type=style&index=0&id=2a1bc641&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bc641",
  null
  
)

export default component.exports